// if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

window.buildColorOptions = function( options ) {

// {
//   key: 'text-color',
//   panel: 'Text Color',
//   prop: 'themeTextColor',
//   class: 'block-text-color',
//   blocks: [
//     'core/button',
//     'core/heading',
//     'core/quote',
//   ],
//   colors: window.BLOCKEDITOR_TEXT_COLORS,
// }

return (function (wp, options) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var Button = wp.components.Button;
  var ButtonGroup = wp.components.ButtonGroup;

  var allowedBlocks = options.blocks;

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        [options.prop]: {
          type: 'string',
          default: ''
        }
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      let colors = options.colors;
      let controls = [];

      for (let colorClass in colors) {
        let colorLabel = colors[colorClass];

        controls.push(
          el(Button, {
            text: colorLabel,
            isPressed: (props.attributes[options.prop] == colorClass),
            className: 'color-' + colorClass,
            onClick: () => props.setAttributes({ [options.prop]: colorClass }),
          })
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: options.panel,
          initialOpen: true
        },
          el(PanelRow, {},
            el(
              ...[ButtonGroup, {
                className: 'color_options'
              }].concat(controls)
            ), // button group
          ),
          el(PanelRow, {},
            el(Button, {
              text: 'Clear',
              isPressed: false,
              isLink: true,
              onClick: () => props.setAttributes({ [options.prop]: '' }),
            })
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (typeof props.attributes[options.prop] !== 'undefined' && allowedBlocks.includes(props.name)) {

        if (typeof props.className === 'undefined') {
          props.className = '';
        }

        let colors = options.colors;

        for (let colorClass in colors) {
          let className = options.class + '-' + colorClass;
          props.className = props.className.replace(`/${className}/g`, '');
        }

        if (props.attributes[options.prop] && props.attributes[options.prop] != 'default') {
          let className = options.class + '-' + props.attributes[options.prop];
          props.className += ' ' + className;
        }
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (typeof attributes[options.prop] !== 'undefined' && allowedBlocks.includes(blockType.name)) {

      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      let colors = options.colors;

      for (let colorClass in colors) {
        let className = options.class + '-' + colorClass;
        extraProps.className = extraProps.className.replace(`/${className}/g`, '');
      }

      if (attributes[options.prop] && attributes[options.prop] != 'default') {
        let className = options.class + '-' + attributes[options.prop];
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/color-options-attributes-' + options.key,
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/color-options-controls-' + options.key,
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/color-options-class-admin-' + options.key,
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/color-options-class-' + options.key,
    applyExtraClass
  );
})(window.wp, options);

};

// }